import 'react-medium-image-zoom/dist/styles.css';

import ProductVideo from '@common/components/ProductVideo';
import ZoomLens from '@common/components/ZoomLens';
import { getYoutubeVideoThumbnail, isMobile, matchYoutubeUrlRegex } from '@common/utils';
import { getLambdaLink } from '@common/utils';
// import { isMobile } from '@common/utils';
import MobileArrow from '@images/Arrow.svg';
import { PlayButtonIcon } from '@instamojo/icons';
// import VerticalGallery from '@common/components/VerticalGallery';
// import Arrow from '@images/GalleryArrow.svg';
// import { ReactComponent as Caret } from '@common/icons/Caret.svg';
import Carousel from '@lib/Carousel';
// import Carousel from '@brainhubeu/react-carousel';
// import { ReactComponent as CarouselArrowRight } from '@common/icons/CarouselArrowRight.svg';
import Image from '@lib/Image';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

export interface GalleryProps {
  className?: string;
  isZoomEnabled: boolean;
  images: string[];
  quickView?: boolean;
  inStock?: boolean;
  imageDescription?: string;
  productVideoUrl?: string;
  productVideoEnabled?: boolean;
}
// interface GalleryListProps {
//   images: Array<string>;
//   setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
//   selectedImage: string;
// }

const Gallery: React.FunctionComponent<GalleryProps> = ({
  // isZoomEnabled = false,
  quickView,
  inStock,
  images = [],
  imageDescription = '',
  productVideoUrl,
  productVideoEnabled,
}) => {
  const [selectedImage, setSelectedImage] = useState(images[0] || '');
  const [selectedVideo, setSelectedVideo] = useState('');
  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');
  const [mouseEnter, setMouseEnter] = useState(false);
  const [LeftArrow, SetLeftArrow] = useState(false);
  const [RightArrow, SetRightArrow] = useState(true);
  const [lensPos, setLensPos] = useState({ left: 0, top: 0 });

  useEffect(() => {
    setSelectedImage(images[0]);
  }, [images]);
  const handleMouseMove = (e) => {
    const { left, top, width, height } = imageRef.current.getBoundingClientRect();
    const minX = Math.min(e.pageX - left, width - 100);
    const minY = Math.min(e.pageY - top, height - 100);
    setLensPos({
      left: minX,
      top: minY,
    });
    setBackgroundPosition(`-${minX * 4}px -${minY * 4}px`);
  };
  const imageRef = useRef(null);
  const zoomedImage = selectedImage.replace(/(.*)(_image\d*_)(.*)/, '$1$2zoom_$3');
  const imagesGallery = [...images];
  if (productVideoEnabled) {
    imagesGallery.push(productVideoUrl);
  }

  return (
    <div className={classnames(' w-full h-full flex flex-col sm:flex-row md:flex-row', {})}>
      <div className={classnames('flex flex-wrap', {})}>
        <div
          className={classnames(
            'relative overflow-visible text-center flex  justify-center w-full h-326 md:w-516 md:h-516',
          )}
        >
          {selectedVideo ? (
            <ProductVideo
              productVideoUrl={selectedVideo}
              height={isMobile() ? '335' : '516'}
              width={isMobile() ? '310' : '516'}
            />
          ) : (
            <div>
              <figure
                onMouseEnter={() => {
                  setMouseEnter(true);
                }}
                onMouseLeave={() => {
                  setMouseEnter(false);
                }}
                onMouseMove={handleMouseMove}
                className="w-full h-full"
              >
                <img
                  ref={imageRef}
                  className={classnames(
                    'm-0 object-contain rounded min-w-full min-w-326 min-h-326 sm:min-w-516 sm:min-h-516 w-full sm:w-326 sm:w-516 h-326 sm:h-516 max-w-full max-h-326 sm:max-w-516 sm:max-h-516',
                    {
                      'opacity-40': !inStock,
                      'bg-opacity-10 bg-black': inStock,
                    },
                  )}
                  loading={'lazy'}
                  src={getLambdaLink({
                    link: selectedImage,
                    width: 0,
                    height: 0,
                  })}
                  alt={imageDescription}
                />
                {!inStock && (
                  <div
                    className={classnames(
                      'absolute flex flex-wrap justify-center rounded content-center top-0 bg-white bg-opacity-30 h-326 md:h-516 min-w-full min-h-326 sm:min-w-516 sm:min-h-516 w-full sm:w-516 max-w-full max-h-326 sm:max-w-516 sm:max-h-516',
                    )}
                  >
                    <button className="relative text-title text-20 md:text-24 leading-30 md:leading-36 font-bold">
                      Out of stock
                    </button>
                  </div>
                )}
                {!quickView && !isMobile() && <ZoomLens lensPos={lensPos} mouseEnter={mouseEnter} />}
              </figure>
              {mouseEnter && !quickView && (
                <div
                  className="hidden md:block absolute rounded-sm z-10 overflow-hidden"
                  style={{
                    left: 600,
                    top: 0,
                    // height: Math.min(imageRef.current?.naturalHeight || 500, 500),
                    // width: Math.min(imageRef.current?.naturalWidth || 500, 500),
                    height: 400,
                    width: 400,
                    backgroundImage: `url('${zoomedImage}'), url('${selectedImage}')`,
                    backgroundPosition,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: `${imageRef.current?.width * 4 || 500}px ${imageRef.current?.height * 4 || 500}px`,
                  }}
                ></div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={classnames('hidden sm:flex md:flex sm:h-516 md:h-516 sm:ml-16 md:ml-10')}>
        {VerticalGallery(
          imagesGallery,
          selectedImage,
          setSelectedImage,
          imageDescription,
          productVideoUrl,
          setSelectedVideo,
          getYoutubeVideoThumbnail,
          selectedVideo,
        )}
      </div>
      <div className="container mt-20 px-0 sm:hidden md:hidden">
        <div
          className={classnames('flex flex-row flex-no-wrap overflow-x-auto hideScroll')}
          id="gallery"
          onScroll={() => {
            const ele = document.getElementById('gallery');
            if (ele.scrollLeft > 100) SetLeftArrow(true);
            else SetLeftArrow(false);
            if (ele.scrollWidth - ele.scrollLeft === ele.clientWidth) SetRightArrow(false);
            else SetRightArrow(true);
          }}
        >
          {imagesGallery.map((image, index) => (
            <div key={index} className="flex">
              {matchYoutubeUrlRegex(image) ? (
                <div
                  className="relative"
                  onClick={() => {
                    setSelectedImage('');
                    setSelectedVideo(productVideoUrl);
                  }}
                >
                  <div className="absolute w-66 h-66 rounded-5 zIndex-999 bg-gray opacity-80 flex items-center justify-center">
                    <PlayButtonIcon size="24" color="#000" />
                  </div>
                  <Image
                    src={getYoutubeVideoThumbnail(productVideoUrl)}
                    alt={imageDescription}
                    className={classnames(
                      'object-contain bg-opacity-10 bg-black rounded mr-6 h-63 w-63 min-w-63 max-w-63',
                      {
                        'opacity-100': selectedVideo === productVideoUrl,
                        'opacity-40': selectedVideo !== productVideoUrl,
                      },
                    )}
                    noDefaultDimensions
                    noDefaultFit
                  />
                </div>
              ) : (
                <Image
                  src={getLambdaLink({
                    link: image,
                    width: 0,
                    height: 0,
                  })}
                  alt="Other Image"
                  className={classnames(
                    'object-contain bg-opacity-10 bg-black rounded mr-6 h-63 w-63 min-w-63 max-w-63',
                    {
                      'opacity-100': selectedImage === image,
                      'opacity-40': selectedImage !== image,
                    },
                  )}
                  key={image}
                  onClick={() => {
                    setSelectedImage(image);
                    setSelectedVideo('');
                  }}
                  noDefaultDimensions
                />
              )}
            </div>
          ))}
        </div>
        {imagesGallery.length > 5 && (
          <div className="relative block md:hidden">
            {LeftArrow && (
              <div className="absolute left-0 top-0 h-full flex items-center pointer-events-none ml-40 -mt-30">
                <button
                  className=" -ml-30 focus:outline-none  pointer-events-auto"
                  onClick={() => {
                    document.getElementById('gallery').scrollBy({
                      top: 0,
                      left: -110,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <div className="h-40 w-40 rounded-full bg-white items-center flex justify-center">
                    <img src={MobileArrow} className="transform rotate-180 fill-current" />
                  </div>
                </button>
              </div>
            )}
            {RightArrow && (
              <div className="absolute right-0 top-0 h-full flex items-center -mt-30 mr-40 lg:-mr-16 pointer-events-none">
                <button
                  className="-mr-30 focus:outline-none pointer-events-auto"
                  onClick={() => {
                    document.getElementById('gallery').scrollBy({
                      top: 0,
                      left: +110,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <div className="h-40 w-40 rounded-full bg-white items-center flex justify-center">
                    <img src={MobileArrow} className="fill-current" />
                  </div>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const VerticalGallery = (
  images,
  selectedImage,
  setSelectedImage,
  imageDescription,
  productVideoUrl,
  setSelectedVideo,
  getYoutubeVideoThumbnail,
  selectedVideo,
) => {
  return (
    <div className="cursor-pointer sm:h-full md:h-full">
      {/* {images.length > 1 && ( */}
      <Carousel
        isVertical
        items={images}
        renderSlide={({ chunkedItem, chunkBy }) => {
          const images = chunkedItem as string[];
          return (
            <div className={'flex flex-col justify-center'}>
              {images.map((image) => (
                <>
                  {matchYoutubeUrlRegex(image) ? (
                    <div
                      className="relative"
                      onClick={() => {
                        setSelectedImage('');
                        setSelectedVideo(productVideoUrl);
                      }}
                    >
                      <div className="absolute w-66 h-66 rounded-5 zIndex-999 bg-gray opacity-80 flex items-center justify-center">
                        <PlayButtonIcon size="24" color="#000" />
                      </div>
                      <Image
                        src={getYoutubeVideoThumbnail(productVideoUrl)}
                        alt={imageDescription}
                        className={classnames(
                          'object-contain bg-opacity-10 bg-black rounded mb-12 h-63 min-w-63 w-63',
                          {
                            'opacity-100': selectedVideo === productVideoUrl,
                            'opacity-40': selectedVideo !== productVideoUrl,
                          },
                        )}
                        noDefaultDimensions
                        noDefaultFit
                      />
                    </div>
                  ) : (
                    <Image
                      src={getLambdaLink({
                        link: image,
                        width: 0,
                        height: 0,
                      })}
                      alt={imageDescription}
                      className={classnames('object-contain bg-opacity-10 bg-black rounded mb-12 h-63 min-w-63 w-63', {
                        'opacity-100': selectedImage === image,
                        'opacity-40': selectedImage !== image,
                      })}
                      key={image}
                      onClick={() => {
                        setSelectedImage(image);
                        setSelectedVideo('');
                      }}
                      noDefaultDimensions
                    />
                  )}
                </>
              ))}
              {[...Array(chunkBy - images.length)].map((key) => (
                <div key={key} className="h-5 w-5" />
              ))}
            </div>
          );
        }}
        breakpoints={[{ width: 0, chunkBy: 7 }]}
        renderControls={({ gotoPrevious, gotoNext, isFirstSlide, isLastSlide }) => {
          return (
            <div style={images.length <= 7 ? { display: 'none' } : null}>
              <div
                className="absolute left-0 top-m15 w-full flex justify-center"
                style={isFirstSlide ? { opacity: 0.7 } : { opacity: 1 }}
              >
                <div className="focus:outline-none -mt-20" onClick={() => (!isFirstSlide ? gotoPrevious() : null)}>
                  <div className="h-48 w-48 rounded-full shadow-arrow bg-white items-center flex justify-center">
                    <img src={MobileArrow} className="w-12  transform -rotate-90 fill-current" />
                  </div>
                </div>
              </div>
              <div
                className="absolute left-0 bottom-m15 w-full flex justify-center"
                style={isLastSlide ? { opacity: 0.7 } : { opacity: 1 }}
              >
                <div className="focus:outline-none" onClick={() => (!isLastSlide ? gotoNext() : null)}>
                  <div className="h-48 w-48 rounded-full shadow-arrow bg-white items-center flex justify-center">
                    <img src={MobileArrow} className="w-12 transform rotate-90 fill-current" />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};
export default Gallery;
